import React from "react";
import { Link } from "react-router-dom";
import "./ui/ui.css";

/**
 * StatusPage – obecná stavová stránka (výsledek akce mimo aplikaci: ověření
 * e-mailu, změna hesla). Karta s ikonou v kruhu, nadpisem, textem a jedním
 * tlačítkem-odkazem. Hlavičku s titulkem dodává AppShell (App.tsx), proto
 * je nadpis karty h2.
 */

export type StatusPageTone = "success" | "info" | "danger";

export interface StatusPageAction {
  label: string;
  /** Cíl v aplikaci (react-router Link). */
  to: string;
}

export interface StatusPageProps {
  /** Ikona bootstrap-icons, např. "bi-envelope-check" (prefix "bi " volitelný). */
  icon: string;
  /** Barva ikony: success = zelená, info = modrá, danger = červená. */
  tone: StatusPageTone;
  title: string;
  text?: React.ReactNode;
  action?: StatusPageAction;
  /** Doplňkový obsah pod textem (nad tlačítkem). */
  children?: React.ReactNode;
}

/** "bi-x", "bi bi-x" i "x" → "bi bi-x" */
const iconClass = (icon: string): string => {
  const name = icon.trim().replace(/^bi\s+/, "");
  return name.indexOf("bi-") === 0 ? `bi ${name}` : `bi bi-${name}`;
};

export const StatusPage: React.FC<StatusPageProps> = ({
  icon,
  tone,
  title,
  text,
  action,
  children,
}) => (
  <div className={`lks-status lks-status--${tone}`}>
    <span className="lks-status__icon" aria-hidden="true">
      <i className={iconClass(icon)} />
    </span>
    <h2 className="lks-status__title">{title}</h2>
    {text ? <p className="lks-status__text">{text}</p> : null}
    {children}
    {action ? (
      <Link to={action.to} className="btn btn-primary lks-status__action">
        {action.label}
      </Link>
    ) : null}
  </div>
);

export default StatusPage;
